import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { FormattedMessage } from 'react-intl';

import ErrorDisplay, { ExtendedErrorDisplayProps } from '..';

import messages from './messages';

const ServiceError = (props: ExtendedErrorDisplayProps) => {
  return (
    <ErrorDisplay Icon={InfoIcon} {...props}>
      <FormattedMessage {...messages.message} />
    </ErrorDisplay>
  );
};

export default ServiceError;
